import { getPurchaseData } from '../../lib/use-cases/get-purchase';

const getSubscriptionId = search => {
    const searchParams = new URLSearchParams(search);
    const subscriptionId = searchParams.get('subscriptionId');

    return subscriptionId || getPurchaseData().subscriptionId;
};

export {
    getSubscriptionId
};
